import * as React from 'react';
import { Alert } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';
import { DateUtils } from '@grandvisionhq/utils';
import { useAppointmentSummarySlotsContext } from '../../../../slots/AppointmentSummarySlotsContext.js';

const AppointmentsList = ({ appointments  })=>{
    const { getLabel , getFormattedLabel  } = useIntl();
    const { Slots: { summary: AppointmentSummary  } ,  } = useAppointmentSummarySlotsContext();
    return /*#__PURE__*/ React.createElement(React.Fragment, null, appointments.some((appt)=>appt.isReservation
    ) && /*#__PURE__*/ React.createElement(Alert, {
        variant: "info",
        title: getLabel('appointments.reservation.infoAlert.title'),
        className: "alert-m-default"
    }, getFormattedLabel('appointments.reservation.infoAlert.message', {
        parseHTML: true
    })), appointments.map((appointment)=>{
        // Check if date is not in the past, otherwise it's not an upcoming appointment
        return !DateUtils.isDateBefore(appointment.startTime, new Date()) ? AppointmentSummary ? /*#__PURE__*/ React.createElement(AppointmentSummary, {
            className: "appointment-summary",
            appointment: appointment,
            key: appointment.id
        }) : null : null;
    }));
};

export { AppointmentsList as default };
//# sourceMappingURL=AppointmentsList.js.map
